module.exports = __webpack_public_path__ + "static/media/64a-preggo.4c15f19d.jpg";